import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

export const createBillingRunRoutesMap = (prefix: string) => ({
  ':id': (id = ':id') =>
    pathJoin(prefix)(id).chainWithTitle({
      title: <T _str="Billing run details" />,
      breadCrumbTitle: <T _str="Billing run details" />,
    }),
  create: pathJoin(prefix)('create').chainWithTitle({
    title: <T _str="New billing run" />,
    breadCrumbTitle: <T _str="New billing run" />,
  }),
})
